// This file is auto-generated by @hey-api/openapi-ts

export const TariffProfilePeriodsEnum = {
    DAY: 'DAY',
    MONTH: 'MONTH',
    YEAR: 'YEAR',
    HALF_YEAR: 'HALF_YEAR',
    MINUTE: 'MINUTE'
} as const;

export type TariffProfilePeriodsEnum = typeof TariffProfilePeriodsEnum[keyof typeof TariffProfilePeriodsEnum];
